import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'
import timg5 from '../images/team/5.jpg'
import timg6 from '../images/team/6.jpg'
import timg7 from '../images/team/7.jpg'
import timg8 from '../images/team/8.jpg'
import timg9 from '../images/team/9.jpg'
import timg10 from '../images/team/10.jpg'
import sajid from '../images/team/Mohammed Sajid Sharfi-1.jpg'
import zubair from '../images/team/Syed Zubair Ahmad-1.jpg'
import ishtiyaq from '../images/team/Mohammed Ishtyaqi-1.jpg'
import sami from '../images/team/Sami Ullah-1.jpg'
import sayeed from '../images/team/Dr. Shaik Sayeed Ahmed Umri Madani.jpg'
import sheikh from '../images/team/Dr. Shaikh Usman Anees Umri.jpg'
import shaikh from '../images/team/Shaik Syed Hussain Umri Madani.jpg'
import hamid from '../images/team/Shaik Mohammad Hamid Madani.jpg'

export const Teams = [
   {
      id: 'abdul-rahman-shakeel',
      tImg: timg1,
      name: 'Abdul Rahman Shakeel',
      title: 'Founder | Director | Trustees',
      description: `Abdul Rahman Shakeel, an astute businessman and visionary leader, the Chief Executive Officer of Nimal Maula Groups, overseeing its diverse portfolio of ventures with a keen eye for innovation and growth. With a background in business management and entrepreneurship, he has steered the company towards new heights of success, fostering a culture of excellence and integrity. Under his leadership, Nimal Maula Groups has expanded its footprint across various industries, setting benchmarks for operational efficiency and corporate responsibility. As the founder and trustee of Nimal Maula Foundation, Abdul Rahman Shakeel is deeply committed to the mission of empowering communities and individuals.\n\nWith a focus on financial literacy and providing interest-free financial solutions, the foundation aims to alleviate poverty and promote economic independence. Abdul Rahman Shakeel’s dedication to social responsibility drives the foundation’s initiatives, making a tangible impact on the lives of those in need.`
   },
   {
      id: 'mohammed-farhan-shajeel',
      tImg: timg2,
      name: 'MD. Farhan Shajeel',
      title: 'Founder | Director | Trustees',
      description: 'Mohammed Farhan Shajeel, an esteemed interior designer renowned for his creative prowess, holds the distinguished positions of founder and Director at Nimal Maula Incociar Projects LLP, a leading firm in the design industry. With a stellar reputation for delivering exceptional design solutions, Mohammed Farhan brings innovation and vision to every project undertaken by the company. Beyond his professional endeavors, he is deeply committed to social welfare and community development.\n\nIn parallel to his role at Nimal Maula Incociar Projects LLP, Mohammed Farhan Shajeel serves as the founder and trustee of Nimal Maula Foundation, a charitable organization dedicated to establishing a riba-free financial system and providing assistance to individuals ensnared in interest-based loans. Driven by a profound sense of compassion and social responsibility, Mohammed Farhan has been actively involved in community service for the past 5 years, spearheading initiatives aimed at promoting financial literacy, alleviating poverty, and empowering marginalized groups. Through his leadership and dedication, he strives to create a more equitable society and uplift those in need.'
   },
   {
      id: 'ameen',
      tImg: timg3,
      name: 'Ameen',
      title: 'Vice President',
      description: 'Ameen, an accomplished management consultant with 16 years of experience in Global Business Services, has demonstrated expertise in risk management, overseeing processes, engaging stakeholders, optimizing operations, and managing teams. He served as a trusted advisor in a Big 4 firm, building and sustaining high-performing teams, scaling business development, and excelling in Project Management, Process optimization, and change management. Certified in Project Management, he excels in translating regulatory policies into efficient workflows.\n\nIn his role as Vice President at NMF, Ameenuddin showcases a robust commitment to social responsibility, community engagement, and upliftment. His leadership is pivotal in driving initiatives aligned with NMF`s mission for positive social impact in RIBA Free communities. Currently leading projects focused on sustainable development and community empowerment, Ameenuddin`s strategic leadership fosters collaborations with diverse stakeholders. His dedication extends beyond business, reflecting a passion for creating a meaningful difference in the lives of those served by the NGO, aligning organizational goals with broader societal needs for lasting community welfare.'
   },
   {
      id: 'mohammed-dawood-pasha',
      tImg: timg4,
      name: 'MD. Dawood Pasha',
      title: 'Vice President',
      description: 'Dawood, Senior Technical Process Developer with around 15 years of experience in different business services, extensively in Infrastructure/Platform/Technology and business management. Most of his experience has been with Change management which basically involves implementing processes and strategies to help individuals and organizations transition from their current state to a desired future state effectively. His experience with change management includes guiding teams through organizational changes, facilitating communications, managing resistance, and ensuring successful adoption of new processes or technologies. Certified in ITIL, Lean Six Sigma Green Belt.\n\nIn his role as Vice President at Nimal Maula Foundation, Dawood entails significant responsibility which manifests in various ways, including ensuring transparency and accountability in operations. He ensures effective utilization of resources for the betterment of communities, upholding ethical standards in all activities and actively contributing to positive social change.'
   },
   {
      id: 'qari-omar-farooq',
      tImg: timg5,
      name: 'Qari Omar Farooq',
      title: 'Vice President',
      description: 'Qari Omar Farooq is an esteemed Quran reciter, renowned for his melodious voice and heartfelt renditions of the Holy Quran. Serving as the imam of Masjid Taqiuddin, he leads congregational prayers and delivers sermons that resonate with the faithful. Alongside his spiritual pursuits, Qari Omar Farooq has also pursued academic excellence, completing a Diploma in Engineering. Despite his busy schedule, he remains committed to community service, recognizing the importance of addressing financial challenges faced by many.\n\nIn his role as a volunteer at Nimal Maula Foundation, Qari Omar Farooq channels his passion for community welfare towards building a riba-free financial system. With a deep understanding of the Quranic principles of financial ethics, he strives to protect individuals ensnared in riba-based loans, offering them guidance and support. Qari Omar Farooq`s dedication to community service is evident in his tireless efforts to promote financial literacy and empower individuals to break free from the shackles of interest-based practices. Through his involvement with Nimal Maula Foundation, he exemplifies the values of compassion, integrity, and social responsibility.'
   },
   {
      id: 'md-ibrahim-ali-khan',
      tImg: timg6,
      name: 'MD. Ibrahim Ali Khan',
      title: 'Vice President',
      description: 'Mohammed Ibrahim Ali Khan, a Director at Nimal Maula Incociar Projects LLP, contributes his expertise to the Interior and Construction company. \nAs a Director at Nimal Maula Incociar Projects LLP, Mohammed Ibrahim Ali Khan brings valuable insight and leadership to the Interior and Construction company\'s operations. \n\nAdditionally, he holds the esteemed position of Vice President at Nimal Maula Foundation, where his dedication lies in establishing a riba-free financial system and protecting individuals ensnared in riba-based loans. With a profound commitment to community service, Mohammed focuses on uplifting and empowering those in need, leveraging his skills and experience for the betterment of society.'
   }
]

export const Volunteers = [
   {
      id: '1',
      tImg: sajid,
      name: 'Mohammed Sajid Sharfi',
      title: 'Volunteer Coordinator',
   },
   {
      id: '2',
      tImg: zubair,
      name: 'Syed Zubair Ahmed',
      title: 'Volunteer',
   },
   {
      id: '3',
      tImg: ishtiyaq,
      name: 'Mohammed Ishtiyaq',
      title: 'Volunteer',
   },
   {
      id: '4',
      tImg: sami,
      name: 'Sami Ullah',
      title: 'Volunteer',
   },
]

export const ShariahExperts = [
   {
      id: '1',
      tImg: sayeed,
      name: 'Dr. Sayeed Ahmed Umri Madani',
      title: 'Shariah Advisor',
   },
   {
      id: '2',
      tImg: sheikh,
      name: 'Dr. Sheikh Usman Anees Umri',
      title: 'Shariah Advisor',
   },
   {
      id: '3',
      tImg: shaikh,
      name: 'Shaikh Syed Hussain Umri Madani',
      title: 'Shariah Advisor',
   },
   {
      id: '4',
      tImg: hamid,
      name: 'Shaikh Mohammed Hamid Madani',
      title: 'Shariah Advisor',
   },
]
